import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "../components/ui/dialog";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export function DecisionDialog({ open, onOpenChange, taskId, decision, onDone }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const titleMap = {
    approve: "Approve plan",
    changes: "Request changes",
    reject:  "Reject plan",
  };
  const needsNote = decision === "changes";

  const submit = async () => {
    if (needsNote && !note.trim()) {
      toast.error("Please add a note describing the changes you need.");
      return;
    }
    setBusy(true);
    try {
      await api.post(`/tasks/${taskId}/decision`, { decision, note });
      toast.success(`Task ${decision === "approve" ? "approved" : decision === "changes" ? "sent back for changes" : "rejected"}.`);
      setNote("");
      onOpenChange(false);
      onDone && onDone();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="decision-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{titleMap[decision]}</DialogTitle>
          <DialogDescription>
            {decision === "approve"
              ? "The agent will start the build immediately."
              : decision === "changes"
              ? "Explain what should change. The agent will replan."
              : "This closes the plan. No build will happen."}
          </DialogDescription>
        </DialogHeader>
        <Textarea
          data-testid="decision-note"
          placeholder={needsNote ? "What needs to change?" : "Optional note…"}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={4}
        />
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="decision-cancel">
            Cancel
          </Button>
          <Button
            onClick={submit}
            disabled={busy}
            data-testid="decision-confirm"
            className={
              decision === "approve"
                ? "bg-emerald-600 hover:bg-emerald-700 text-white"
                : decision === "reject"
                ? "bg-rose-600 hover:bg-rose-700 text-white"
                : ""
            }
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
